import 'react-hot-loader/patch';

import React                                     from 'react';
import { render }                                from 'react-dom';
import { AppContainer as ReactHotLoader }        from 'react-hot-loader';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk                                     from 'redux-thunk';
import { Provider }                              from 'react-redux';

import Root         from '../mylar_and_kapton_stencils/containers/Root';
import Cart         from '../mylar_and_kapton_stencils/containers/Cart';
import reducer      from '../mylar_and_kapton_stencils/reducers';
import DefaultState from '../mylar_and_kapton_stencils/data/DefaultState';

const middleware = [thunk];

let composeEnhancers;
if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
  composeEnhancers = compose;
}
// const composeEnhancers = compose;

const store = createStore(
  reducer,
  DefaultState,
  composeEnhancers(applyMiddleware(...middleware)),
);


const renderApp = (Component, targetId = 'quote-form') => {
  render(
    <ReactHotLoader>
      <Provider store={store}>
        <Component />
      </Provider>
    </ReactHotLoader>,
    document.getElementById(targetId),
  );
};

document.addEventListener('DOMContentLoaded', () => {
  renderApp(Root);
  renderApp(Cart, 'cart-form');
});

if (module.hot) {
  module.hot.accept(
    ['../mylar_and_kapton_stencils/containers/Root', '../mylar_and_kapton_stencils/containers/Cart', '../mylar_and_kapton_stencils/reducers'],
    () => renderApp(Root),
  );
}
